import type { BlogPost } from '@types'

// A post with no date renders "Date unavailable", never today's date: matches [post]/page.tsx. [S20-1320]
// In UTC, not the server's zone, so the shown day matches the page's UTC same-day check. [S20-1417]
export function formatPostDate(timestamp?: number): string {
  return timestamp && Number.isFinite(timestamp)
    ? new Intl.DateTimeFormat('en-US', { month: 'short', day: '2-digit', year: 'numeric', timeZone: 'UTC' }).format(
        new Date(timestamp),
      )
    : 'Date unavailable'
}

// WordPress can answer without a usable date_gmt (NaN): `toISOString()` would throw, so callers omit the field. [S20-1417]
export function isoDate(timestamp?: number): string | undefined {
  return Number.isFinite(timestamp) ? new Date(timestamp as number).toISOString() : undefined
}

// The WordPress slug, which the editors choose, not the title cut to 64 characters plus the id. [S20-1385]
export function postUrl(post: Pick<BlogPost, 'slug'>): string {
  return `/blog/${post.slug}`
}
